import React from 'react'
import {withRouter} from 'react-router';
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import ChipUserAccount from "../../components/ChipUserAccount";
import CuentaSelected from "../../helpers/CuentaSelected";
import Api from "../../helpers/Api";
import Env from "../../config/env";
import SuspensionsList from "./SuspensionsList";

class Suspensions extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            suspensionsList: [],
        };
    }

    async componentDidMount() {
        await this.getSuspensions();
    }

    getSuspensions = async () => {
        const account = CuentaSelected.get()
        const data = await Api.get(`${Env.UrlSeguridad}/getVSuspensionesWeb/${account.cuentaCodigo}`);
        if (data.cod === '1') {
            this.setState({
                suspensionsList: data.V_SUSPENSIONES_WEB,
            });
        }
    }

    render() {
        return (
            <div style={{minHeight: '500px', textAlign: 'center'}}>

                <AppBreadcrumbs
                    links={[
                        {
                            url: 'accounts',
                            label: 'Cuentas'
                        },
                        {
                            url: 'menu',
                            label: 'Menú'
                        }
                    ]}
                    actual='Suspensiones'
                />

                <h2>
                    <ChipUserAccount/>
                    <span>Suspensiones</span>
                </h2>

                <div>
                    <SuspensionsList data={this.state.suspensionsList} />
                </div>

            </div>
        );
    }
}

export default withRouter(Suspensions)